import type { ReactNode } from 'react'
import React from 'react'
import type { TextProps } from '@vtex/admin-ui'
import { Text, csx, cx } from '@vtex/admin-ui'

export type SalesPeriodDrawerSubTitleProps = {
  children: ReactNode
} & TextProps

export const SalesPeriodDrawerSubTitle = ({
  children,
  className = '',
  ...props
}: SalesPeriodDrawerSubTitleProps) => (
  <Text
    className={cx(
      csx({
        marginBottom: '$space-4',
        '@desktop': {
          marginBottom: '$space-6',
        },
        text: '$body',
      }),
      className
    )}
    {...props}
  >
    {children}
  </Text>
)
